import { render } from "./InstallScreen.vue?vue&type=template&id=d3299330&scoped=true"
import script from "./InstallScreen.vue?vue&type=script&lang=js"
export * from "./InstallScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=d3299330&lang=scss&scoped=true"
import "./InstallScreen.vue?vue&type=style&index=1&id=d3299330&scoped=true&lang=scss"

import exportComponent from "/var/www/html/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3299330"]])

export default __exports__